export default __webpack_public_path__ + "static/media/Jogo-Do-Bicho_No-music_1.04e0f97e.svg";